import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import VersionList from './VersionList';
import UploadButton from './UploadButton';
import styles from './History.m.sass';
var History = function History(_ref) {
  var view = _ref.view;
  var hasAnyVersions = view.document.history.length > 0;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.root)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, hasAnyVersions ? /*#__PURE__*/React.createElement(VersionList, {
    view: view
  }) : /*#__PURE__*/React.createElement(NoHistory, null)), view.document.canEdit && /*#__PURE__*/React.createElement("div", {
    className: cx(styles.footer)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.actions
  }, /*#__PURE__*/React.createElement(UploadButton, {
    onChange: function onChange(files) {
      return view.replaceContents(Array.from(files));
    },
    loading: view.replaceContents.pending
  }, "Upload"))));
};
var NoHistory = function NoHistory() {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.noFiles
  }, "This document has no history yet.");
};
export default observer(History);
//# sourceMappingURL=index.js.map
